import React, { useState, useEffect } from 'react';
import bg from "../assets/bg.jpeg";
import logo from "../assets/mia.png";
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import Offer from './MiaLayout/Offer';
import Generic from './MiaLayout/Generic';
import google from "../assets/google.png";
import "../App.css"

const MiaLayout = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const storecode = urlParams.get("storeCode");
    const [branchInfo, setBranchInfo] = useState([]);
    const [ugc, setUgc] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [offerContent, setOfferContent] = useState([]);
    const [currentOfferIndex, setCurrentOfferIndex] = useState(0);
    const [currentGenericIndex, setCurrentGenericIndex] = useState(0);
    const [status, setStatus] = useState(0);
    const [apiBackgroundColor, setApiBackgroundColor] = useState(null);

    const fetchReviews = async () => {
        try {
            const requestBody = new URLSearchParams();
            requestBody.append('BranchId', storecode);

            const reviewsResponse = await fetch('https://api-digitalwall.xploro.io/Digitalwall/DigitalwallDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: requestBody,
            });

            if (!reviewsResponse.ok) {
                const errorData = await reviewsResponse.json();
                throw new Error(`Reviews request error! Status: ${reviewsResponse.status}, Details: ${JSON.stringify(errorData)}`);
            }

            const reviewsData = await reviewsResponse.json();
            setBranchInfo(reviewsData.config.BranchInfo);
            setApiBackgroundColor(reviewsData.config.BranchInfo.ColorTheme)
            setUgc(reviewsData.Data.Content);
                const genericItems = reviewsData.Data.Content?.filter(item => item.ContentCategoryName === 'Generic');
                const offerItems = reviewsData.Data.Content?.filter(item => item.ContentCategoryName === 'Offers');
                preloadUrlsUGC(reviewsData.Data.Content)
                setStatus(offerItems?.length>0?1:2)
                setGenericContent(genericItems);
                setOfferContent(offerItems);
            

        } catch (error) {
            console.error('Error fetching reviews:', error.message);
        }
    };

    useEffect(() => {
        fetchReviews();
    }, []);

    useEffect(() => {
        const callApi = async () => {
          try {
            const requestBody = new URLSearchParams();
            requestBody.append('StoreCode', storecode);

            const response = await fetch('https://api-digitalwall.xploro.io/ScreenMonitoring/ActivityCheck', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: requestBody,
            });
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log(data);
          } catch (error) {
            console.error('Error calling /ScreenMonitoring/ActivityCheck:', error);
          }
        };
    
        // Call the API initially
        callApi();
    
        // Set up the interval to call the API every two minutes
        const intervalId = setInterval(callApi, 120000); // 120000 ms = 2 minutes
    
        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalId);
      }, []);

    const cache = {}; // Define a cache object to store loaded images and videos

    const preloadUrlsUGC = (data) => {
        if (!Array.isArray(data)) {
            console.log("Data is not an array");
            return;
        }
    
        data.forEach((item) => {
            if (!item || !item.ContentURL) {
                console.log("UGC data is missing or invalid in an item");
                return;
            }
    
            if (cache[item.ContentURL]) {
                console.log("Item already cached:", item.ContentURL);
                return;
            }

            const container = document.createElement("div");
            container.style.opacity = 0;

            if (isImage(item.ContentURL)) {
                const img = document.createElement("img");
                img.src = item.ContentURL;
                container.appendChild(img);
            } else {
                const video = document.createElement("video");
                video.autoplay = true;
                video.loop = true;
                video.muted = true;
                video.controls = false;
                video.src = item.ContentURL;
                video.addEventListener("loadeddata", () => {
                    cache[item.ContentURL] = true;
                    console.log("Video cached:", item.ContentURL);
                });
                container.appendChild(video);
            }
            document.body.appendChild(container);
        });
    };

    useEffect(() => {
        const timeout1 = setTimeout(() => {
            if (status === 1 && offerContent?.length > 0) {
                setCurrentOfferIndex(prevIndex => (prevIndex + 1) % offerContent?.length);
                if(genericContent?.length>0){
                    setStatus(2);
                }
                
            }
        }, offerContent&&offerContent[currentOfferIndex]?.Duration*1000 || 1000);
        let videoDuration = null;
    
        const timeout2 = setTimeout(() => {
            if (status === 2 && genericContent?.length > 0) {
                setCurrentGenericIndex(prevIndex => (prevIndex + 1) % genericContent?.length);
                if (offerContent.length > 0) {
                    setStatus(1);
                }
            }
        }, isImage(genericContent&&genericContent[currentGenericIndex]?.ContentURL) ? 20000 : (videoDuration || 20000));
    
        getVideoDuration(genericContent&&genericContent[currentGenericIndex]?.ContentURL)
            .then(duration => {
                videoDuration = duration * 1000; 
                clearTimeout(timeout2); 
                setTimeout(() => {
                    if (status === 2 && genericContent.length > 0) {
                        setCurrentGenericIndex(prevIndex => (prevIndex + 1) % genericContent.length);
                        if (offerContent.length > 0) {
                            setStatus(1);
                        }
                    }
                }, isImage(genericContent[currentGenericIndex]?.ContentURL) ? 20000 : (videoDuration || 20000)); 
            })
            .catch(error => {
                console.error('Error getting video duration:', error);
                // Handle error appropriately
            });
    
        return () => {
            clearTimeout(timeout1);
            clearTimeout(timeout2);
        };
    }, [status, genericContent, offerContent,currentGenericIndex,currentOfferIndex]);
    

    const isImage = (url) => {
        if (!url) return false; 
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp','.webp'];
        return imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
    };

    const getVideoDuration = async (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.oncanplaythrough = () => {
            const durationInSeconds = Math.floor(video.duration);
            resolve(durationInSeconds); // Duration in seconds
            video.remove(); // Remove the video element after obtaining the duration
        };
        video.onerror = () => {
            reject(new Error('Unable to load video'));
            video.remove(); // Remove the video element in case of an error
        };
        video.src = url;
        video.load();
    });
}; 
    

    return (
        <div>
            <div style={{ position: "absolute", top: 0, left: 0, width: "100vw", height: "100vh",backgroundImage: `url(${branchInfo.BranchBGURL})`, backgroundSize: 'cover', opacity: 0.07 }}></div>
            {branchInfo?.Layout==="Portrait"?(
            <div>
                {/* <img src={branchInfo.LogoURL} style={{width:"20vw",position:"absolute",top:"50%",left:"50%",transform:"translateX(-50%)",zIndex:"-1"}}/> */}
                {/* <img src={branchInfo.LogoURL} style={{ width: "14vw", position: "absolute", bottom: "1.5vh", left: "4vw" }} alt="Logo" /> */}
                {/* <p style={{ color: "white", position: "absolute", left: "6vw", fontSize: "3vw", fontWeight: "600", width: "35vw", margin: "0", bottom: "4.5vh" }}>{branchInfo.StoreDisplayName}</p> */}
               {branchInfo.GoogleAverageRating>0&&
                <div style={{ display: "flex", flexDirection: "row",gap:"1vw",alignItems:"center", position: "absolute", bottom: "3vh", right: "5vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
                <img src={google} alt="Google" style={{ width: "8vw", height: "auto", backgroundColor: "white", borderRadius: "50%", padding: "2px" }} />
                    <div style={{ display: "flex",flexDirection:"column", gap: "1.5vw", justifyContent: "center", alignItems: "center" }}>
                        <p style={{ margin: "0", fontSize: "5vw", color: "white", fontWeight: "600",lineHeight:"0.7" }}>{branchInfo.GoogleAverageRating}</p>
                        <div style={{ display: "flex", gap: "0.5vw", justifyContent: "center" }}>
                            {Array(5).fill().map((_, i) => {
                                if (i < Math.floor(branchInfo.GoogleAverageRating)) {
                                    return (
                                        <div key={i}>
                                            <FaStar color="gold" size={25} />
                                        </div>
                                    );
                                } else if (i === Math.floor(branchInfo.GoogleAverageRating)) {
                                    return (
                                        <div key={i}>
                                            <FaStarHalfAlt color="gold" size={25} />
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={i}>
                                            <FaRegStar color="gold" size={25} />
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                   
                </div>
                        }
            </div>
            ):(
                branchInfo.GoogleAverageRating>0 &&
                <div>
                <img src={branchInfo.LogoURL} style={{ width: "8vw", position: "absolute", top: "1vh", left: "50%",transform:"translateX(-50%)" }} alt="Logo" />
                <p style={{ color: "white", position: "absolute", left: "10vw", fontSize: "1.9vw",fontWeight:"600" }}>{branchInfo.StoreDisplayName}</p>
                <div style={{ display: "flex", flexDirection: "row", gap: "0.5vw", position: "absolute", top: "2vh", right: "13vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
                  <img src={google} alt="Google" style={{ width: "4.5vw", height: "auto" }} />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", gap: "0.5vw", justifyContent: "center" }}>
          {Array(5).fill().map((_, i) => {
            if (i < Math.floor(branchInfo.GoogleAverageRating)) {
              return (
                <div key={i}>
                  <FaStar color="gold" size={25} />
                </div>
              );
            } else if (i === Math.floor(branchInfo.GoogleAverageRating)) {
              return (
                <div key={i}>
                  <FaStarHalfAlt color="gold" size={25} />
                </div>
              );
            } else {
              return (
                <div key={i}>
                  <FaRegStar color="gold" size={25} />
                </div>
              );
            }
          })}
        </div>
                    <p style={{ margin: "0", fontSize: "1.7vw", color: "white",fontWeight:"600" }}>{branchInfo.GoogleAverageRating} stars, {branchInfo.TotalGoogleReviewCount} reviews</p>
                  </div>
                </div>
              </div>
            )}
            {status === 1 && offerContent?.length > 0 &&  offerContent[currentOfferIndex] && <Offer offer={offerContent[currentOfferIndex].ContentURL} />}
            {status === 2 && genericContent?.length > 0 && genericContent[currentGenericIndex] && <Generic generic={genericContent[currentGenericIndex].ContentURL} />}
        </div>
    );
}

export default MiaLayout;
